module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_39.50804f0c.png";